module.exports = __webpack_public_path__ + "static/media/inactive_trials.3ec1c05b.png";